const initialState = window.CLIENT_PARAMS.initialState || {};

export default initialState;
